import developmentConfig from '@/config/development'
import productionConfig from '@/config/production'
// import productionConfigTw from '@/config/productiontw'
const baseConfig = {

}
if (process.env.NODE_ENV === 'development') {
  Object.assign(baseConfig, developmentConfig)
}
if (process.env.NODE_ENV === 'production') {
  Object.assign(baseConfig, productionConfig)
}
// if (process.env.NODE_ENV === 'production_tw') {
//     Object.assign(baseConfig, productionConfigTw)
// }
export default baseConfig



// WEBPACK FOOTER //
// ./src/config/index.js